// extracted by mini-css-extract-plugin
export default {"AssignedPersonality":"XQnD8kBr","Select":"TQ6gknU6","EditBtn":"dqL4bS1v"};